import { render } from "./Criar.vue?vue&type=template&id=7838a07f&scoped=true"
import script from "./Criar.vue?vue&type=script&lang=js"
export * from "./Criar.vue?vue&type=script&lang=js"

import "./Criar.vue?vue&type=style&index=0&id=7838a07f&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7838a07f"]])

export default __exports__